import React from "react";

export const intialConsentState = {
  necessary: true,
  preferences: false,
  statistics: false,
  marketing: false,
};

export const useCookiebotConsent = (
  onAccept = () => {},
  onDisable = () => {}
) => {
  const [consent, setConsent] = React.useState(intialConsentState);

  const handleCookiebotAccept = () => {
    // eslint-disable-next-line no-undef
    const { necessary, preferences, statistics, marketing } = Cookiebot.consent;
    if (
      consent.necessary !== necessary ||
      consent.preferences !== preferences ||
      consent.statistics !== statistics ||
      consent.marketing !== marketing
    ) {
      setConsent({ necessary, preferences, statistics, marketing });
    }
    onAccept();
  };

  const handleCookiebotDisable = () => {
    // eslint-disable-next-line no-undef
    const { necessary, preferences, statistics, marketing } = Cookiebot.consent;
    if (
      consent.necessary !== necessary ||
      consent.preferences !== preferences ||
      consent.statistics !== statistics ||
      consent.marketing !== marketing
    ) {
      setConsent({ necessary, preferences, statistics, marketing });
    }
    onDisable();
  };

  React.useEffect(() => {
    // Add event listeners for Cookiebot events
    window.addEventListener("CookiebotOnAccept", handleCookiebotAccept, false);
    window.addEventListener(
      "CookiebotOnDecline",
      handleCookiebotDisable,
      false
    );

    return () => {
      window.removeEventListener(
        "CookiebotOnAccept",
        handleCookiebotAccept,
        false
      );
      window.removeEventListener(
        "CookiebotOnDecline",
        handleCookiebotDisable,
        false
      );
    };
  }, [consent]);

  return consent;
};
